import { flow, types } from 'mobx-state-tree'
import { getVoucherList } from '../../../network/refund/getVoucherList'
import { resendVoucher } from '../../../network/refund/resendVoucher'
import { pkceBase64URLEncode } from '../../../util/utill'
import { RootStore } from '../../store'
import { RefundCustomerDetails } from './RefundCode'

const BeneficiaryDetails = types.model('BeneficiaryDetails', {
  beneName: types.maybeNull(types.string),
  beneAccNum: types.maybeNull(types.string),
})

const RefundDetails = types.model('RefundDetails', {
  voucherId: (types.string, ''),
  voucherReferenceNumber: (types.string, ''),
  transactionDate: types.optional(types.number, 0),
  voucherAmount: types.optional(types.number, 0),
  originalTranId: types.optional(types.string, ''),
  utr: types.maybeNull(types.string),
  voucherStatus: types.optional(types.enumeration(['ACTIVE', 'REDEEM_IN_PROGRESS', 'REDEEMED']), 'ACTIVE'),
  remittanceDetails: types.optional(RefundCustomerDetails, {}),
  beneficiaryDetails: types.optional(BeneficiaryDetails, {}),
})

const ReGenerateRefundCode = types
  .model('ReGenerateRefundCode', {
    reGeneratedRefundCode: types.optional(types.string, ''),
    userEnteredRefundCode: types.optional(types.string, ''),
    methodType: types.optional(types.string, ''), //Or Method Type
    mobile: types.optional(types.string, ''), //Or Method Type
    pendingRefunds: types.array(RefundDetails),
    utrRefRefundDetails: types.optional(RefundDetails, {}),
    refundCodeGenerationStatus: types.optional(types.string, ''),
    utrReferenceCodeNumber: types.optional(types.string, ''),
  })
  .actions((self) => ({
    getVoucherListApi: flow(function* getVoucherListApi(body: any, type: 'LIST' | 'UTR_REF') {
      try {
        //remitterId="1662358270850013081"
        const resp = yield getVoucherList(RootStore?.agent?.session, body)
        console.log('res', resp)
        if (type === 'LIST') self.pendingRefunds = resp
        else {
          self.utrRefRefundDetails = resp
        }

        return resp
      } catch (err) {
        console.log(err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    resendVoucherApi: flow(function* resendVoucherApi(voucherId: string) {
      try {
        const resp = yield resendVoucher(RootStore?.agent?.session, voucherId, RootStore?.customer?.remittanceUserId)
        console.log('res', resp)
        return resp
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateRefundCode(val: string) {
      self.userEnteredRefundCode = val
    },
    updateMethodType(val: string) {
      self.methodType = val
    },
    updateUtrReferenceCode(val: string) {
      self.utrReferenceCodeNumber = val
    },
    updateCustomerMobile(val: string) {
      self.mobile = val
    },
    getPendingRefunds: flow(function* getPendingRefunds() {
      try {
        const response = yield pkceBase64URLEncode('')
        self.pendingRefunds = response
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    generateRefundCode: flow(function* generateRefundCode() {
      try {
        const response = yield pkceBase64URLEncode('')
        self.reGeneratedRefundCode = response?.reGeneratedRefundCode
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
  }))
  .views((self) => ({
    getMobileNum: () => {
      return self.utrRefRefundDetails.remittanceDetails.mobileNumber.number
    },
  }))

const ReGenerateRefundCodeData = ReGenerateRefundCode.create({})

export { ReGenerateRefundCode, ReGenerateRefundCodeData }
